import { UseFormReturn } from 'react-hook-form';
import { FormField, FormItem, FormMessage } from '@@/ui/primitives';
import { Field, SchemaFieldType } from '../../../../schemas/entity';
import { CreateItemPayload } from '../../../../schemas/item';
import { ReferenceInput } from '../../../shared/field-inputs';

interface ReferenceFieldRendererProps {
  fieldKey: string;
  field: Field;
  form: UseFormReturn<CreateItemPayload['attributes']>;
  label: string;
  disabled?: boolean;
}

export function ReferenceFieldRenderer({
  fieldKey,
  field,
  form,
  label,
  disabled = false
}: ReferenceFieldRendererProps) {
  if (field.definition.type !== SchemaFieldType.REFERENCE) {
    throw new Error('Field definition type mismatch for type: `reference`');
  }

  // TODO: Change
  const entityId = field.definition.entityId;

  return (
    <FormField
      control={form.control}
      name={fieldKey}
      render={({ field: formField }) => (
        <FormItem>
          <ReferenceInput
            baseEntityId={entityId}
            value={formField.value || ''}
            onChange={formField.onChange}
            label={label}
            placeholder={`Select ${fieldKey}...`}
            disabled={disabled}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
